export var NumericalOperationType;
(function (NumericalOperationType) {
    NumericalOperationType[NumericalOperationType["ProportionalConversion"] = 2] = "ProportionalConversion";
    NumericalOperationType[NumericalOperationType["Zoom"] = 4] = "Zoom";
})(NumericalOperationType || (NumericalOperationType = {}));
